import '@fontsource-variable/unbounded/wght.css'
import '@fontsource-variable/jost/wght.css'

import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import { dispatch } from '@/scripts/helpers'
import resize from '@alpinejs/resize'
import focus from '@alpinejs/focus'

import '@/scripts/modules/bootstrap'
import '@/scripts/modules/measure'
import '@/scripts/modules/elemTracker'
//import 'modules/observeGroup'
import '@/scripts/modules/screen'
import '@/scripts/modules/mouseSpy'
import '@/scripts/modules/form'
import '@/scripts/modules/scrollRotator'
import '@/scripts/modules/scrollSync'
import '@/scripts/modules/counter'
import '@/scripts/modules/accordion'
import '@/scripts/modules/slider'
import '@/scripts/modules/masonry'
import '@/scripts/modules/tooltips'
import '@/scripts/modules/parallax'
import '@/scripts/modules/tilt'
import '@/scripts/modules/lightbox'
import '@/scripts/modules/modal'
import '@/scripts/modules/sizesCollection'
import '@/scripts/modules/scrollProgress'

import '@/scripts/modules/marquee'
import '@/scripts/modules/containerAnimation'

const FETCH_CONFIG = {
  mode: 'cors',
  credentials: 'same-origin',
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
  }
}

Alpine.plugin(intersect)
Alpine.plugin(resize)
Alpine.plugin(focus)

Alpine.store('app', {
  scrollY: window.scrollY,
  setGlobal(key, value) {
    document.documentElement.style.setProperty(
      `--${key}`,
      value
    )
  },
  syncHeight(key, el) {
    this[key].height = el.offsetHeight

    try {
      new ResizeObserver((entries) => {
        this.$nextTick(() => {
          const newHeight = entries[0].contentRect.height
          if (this[key].height !== newHeight) this[key].height = newHeight
        })
      }).observe(el)
    } catch (error) {
      // no resize observer possible
      console.log(error)
    }
  },
  syncScrollHeight(el, key, context) {
    try {
      new ResizeObserver(() => {
        context.$nextTick(() => {
          const newHeight = el.scrollHeight
          if (context[key] !== newHeight) context[key] = newHeight
        })
      }).observe(el)
    } catch (error) {
      // no resize observer possible
      console.log(error)
    }

    return el.scrollHeight
  },
  init() {
    window.addEventListener('scroll', () => {
      Alpine.store('app').scrollY = window.scrollY
    })

    try {
      // measure scrollbar width
      new ResizeObserver(() => {
        if (window.getComputedStyle(document.documentElement).getPropertyValue('overflow-y') !== 'hidden') {
          this.setGlobal('scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth}px`)
        }
      }).observe(document.body)
    } catch {}
  },
})

Alpine.store('scroll', {
  inProgress: false,
  init() {
    let timeout = null
    window.addEventListener('scroll', () => {
      this.inProgress = true

      // failsafe
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        this.inProgress = false
      }, 1000)
    }, { passive: true })
    window.addEventListener('scrollend', () => {
      this.inProgress = false
    }, { passive: true })
  }
})

window.app = {
  settings: {},
  track(...args) {
    if (!window._paq || typeof window._paq !== 'object') return
    window._paq.push(['trackEvent', ...args])
  },
  setHash: (hash) => {
    history.pushState({}, '', hash)
    dispatch('programmatichashchange')
  },
  submitAndHide: (btn, parent, cb) => {
    const form = btn.closest('form')
    const xhr = new XMLHttpRequest()
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        parent.style.display = 'none'
        //window.location.reload()
        if (cb) cb()
      }
    }
    xhr.open('POST', form.action)
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    xhr.send(serializeForm(form, btn))
  },
}

// reading progress
const readingProgrssSource = document.querySelector('.reading-progress-source')
if (readingProgrssSource) {
  import('@/scripts/modules/readingProgress').then((prog) =>
    prog.default(readingProgrssSource)
  )
}

// accordions
if (document.querySelectorAll('.hljs').length) {
  import('highlight.js/styles/monokai.css')
}

if (document.getElementById('matomo-opt-out')) {
  import('@/scripts/modules/matomo').then((mod) => mod.default())
}


function serializeForm(form, clickedButton) {
  let serialized = []

  for (let i = 0; i < form.elements.length; i++) {
    let field = form.elements[i]

    if (
      !['checkbox', 'radio', 'button'].includes(field.type) ||
      field.checked
    ) {
      serialized.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      )
    }
  }
  serialized.push(encodeURIComponent(clickedButton.getAttribute('name')) + '=')

  // Combine the pairs into a single string and replace all %-encoded spaces to
  // the '+' character; matches the behavior of browser form submissions.
  return serialized.join('&').replace( /%20/g, '+' )
}

// async html
Alpine.data('frame', function (href, lazy = false) {
  return {
    content: null,
    insert(target, type = 'div') {
      const element = document.createElement(type)
      element.innerHTML = this.content
      target.appendChild(element)
    },
    replace(target, outer = true) {
      outer
        ? (target.outerHTML = this.content)
        : (target.innerHTML = this.content)
    },
    evtHandler: {
      ['@click.prevent']() {
        this.trigger()
      },
    },
    async trigger() {
      const url = new URL(href, window.location)
      url.searchParams.append('_ajax', true)
      url.searchParams.append('pimcore_nocache', true)

      // prevent attacks
      if (
        process.env.NODE_ENV !== 'development' &&
        !(window.location.hostname === url.hostname || !url.hostname.length)
      )
        return

      try {
        const resp = await fetch(url.href, FETCH_CONFIG)
        const content = await resp.text()
        if (content && content.trim().length > 0) this.content = content
      } catch (error) {
        console.warn('Error loading frame:', error)
      }
    },
    init() {
      if(!lazy) this.trigger()
    },
  }
})

window.Alpine = Alpine
Alpine.start()
